/* ============
 * Mutations for the resolve module
 * ============
 *
 * The mutations that are available on the
 * resolve module.
 */

import types from './mutation-types';

export default {
  [types.FETCH_RESOLVE_ACTIONS](state) {
    state.loading = true;
  },
  [types.FETCH_RESOLVE_ACTIONS_SUCCESS](state, response) {
    state.loading = false;
    state.resolveActionsList = response;
  },
  [types.FETCH_RESOLVE_ACTIONS_FAIL](state, error) {
    state.loading = false;
    state.error = error;
  }
};
